import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import { Button, Table, message, DatePicker, Pagination } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class GameStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            date: [],
        },
        data: [], // 表格数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/union_list_statistic", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/union_list_statistic_to_excel", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "day")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gain"]}
                            dataIndex="gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["paymentStatistic"]}
                            dataIndex="submit_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchSum"]}
                            dataIndex="match_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gamePepoleNumber"]}
                            dataIndex="player_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handCardNumber"]}
                            dataIndex="hands_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["pvpProfitSum"]}
                            dataIndex="profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cbProfitSum"]}
                            dataIndex="cb_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyBettingAmount"]}
                            dataIndex="cb_buy_in_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyBetAmount"]}
                            dataIndex="cb_hands_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceInvestmentAmount"]}
                            dataIndex="ins_buy_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFee"]}
                            dataIndex="fee_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insProfitSum"]}
                            dataIndex="ins_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["luckycard"]}
                            dataIndex="luckycard"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["jackpot"]}
                            dataIndex="jackpot"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["openNumberStatistics"]}
                            dataIndex="match_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["joinPeopleNumberStatistics"]}
                            dataIndex="player_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handNumberStatistics"]}
                            dataIndex="hands_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfitStatistics"]}
                            dataIndex="profit_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeStatistics"]}
                            dataIndex="fee_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceStatistics"]}
                            dataIndex="ins_profit_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceBuyInStatistics"]}
                            dataIndex="ins_buy_sum_detail"
                        />
                    </Table>
                    <Pagination
                        className="pagination"

                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>
            </div>
        );
    }
}
